export function parseMoneyBR(value: unknown): number {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;

  const raw = String(value ?? "").trim();
  if (!raw) return 0;

  const negative = raw.includes("-");
  const sanitized = raw.replace(/[^\d.,]/g, "");
  if (!sanitized) return 0;

  const lastComma = sanitized.lastIndexOf(",");
  const lastDot = sanitized.lastIndexOf(".");
  let normalized = sanitized;

  if (lastComma >= 0 && lastDot >= 0) {
    const decimalSeparator = lastComma > lastDot ? "," : ".";
    const thousandSeparator = decimalSeparator === "," ? "." : ",";
    normalized = sanitized.split(thousandSeparator).join("").replace(decimalSeparator, ".");
  } else if (lastComma >= 0) {
    const parts = sanitized.split(",");
    const decimalDigits = parts.at(-1)?.length || 0;
    normalized = decimalDigits <= 2
      ? `${parts.slice(0, -1).join("")}.${parts.at(-1)}`
      : parts.join("");
  } else if (lastDot >= 0) {
    const parts = sanitized.split(".");
    const decimalDigits = parts.at(-1)?.length || 0;
    const allThousands = parts.length > 1 && parts.slice(1).every((part) => part.length === 3);
    normalized = allThousands || decimalDigits > 2
      ? parts.join("")
      : `${parts.slice(0, -1).join("")}.${parts.at(-1)}`;
  }

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) return 0;
  return negative ? -Math.abs(parsed) : parsed;
}

export function roundMoney(value: unknown): number {
  return Math.round((parseMoneyBR(value) + Number.EPSILON) * 100) / 100;
}

export function formatMoneyInput(value: unknown): string {
  return roundMoney(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatCurrencyBRL(value: unknown): string {
  return roundMoney(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
